import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from "./plugins/router";
import "./axios";
import store from "./store";
import moment from 'moment';
import "@/global.css"
import notification from "@/notifications/notification";
import UUID from "vue-uuid";

import DataTable from "@/components/DataTable";
Vue.component("DataTable",DataTable);
Vue.config.productionTip = false
Vue.prototype.moment = moment;
Vue.use(notification);
Vue.use(UUID);

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
